import { List, OrderedMap } from 'immutable';
import * as ActionTypes from '../actions/ActionTypes';
import HomepageOrganizationRecord from '../records/HomepageOrganizationRecord';
import HomepageCategoryRecord from '../records/HomepageCategoryRecord';
const INITIAL_STATE = new HomepageOrganizationRecord();
function fromPayload(knowledgeCategories = []) {
  return new HomepageOrganizationRecord({
    knowledgeCategories: knowledgeCategories.reduce((acc, knowledgeCategory) => acc.set(knowledgeCategory.categoryId, HomepageCategoryRecord.fromKnowledgeHomepageCategoryJS(knowledgeCategory)),
    // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
    new OrderedMap())
  });
}
export default function reducer(state = INITIAL_STATE, {
  payload,
  type
}) {
  switch (type) {
    case ActionTypes.FETCH_TEMPLATE_SETTINGS_SUCCESS:
      {
        const {
          homepageCategories
        } = payload;
        return fromPayload(homepageCategories);
      }
    case ActionTypes.TEMPLATE_EDITOR_TOGGLE_CATEGORY_ON_HOME_PAGE:
      {
        const {
          categoryId: knowledgeCategoryId,
          isDisplayed
        } = payload;
        return state.updateIn(['knowledgeCategories', knowledgeCategoryId], category => {
          if (category) {
            return category.merge({
              isDisplayed
            });
          }
          return HomepageCategoryRecord.fromJS({
            isDisplayed,
            knowledgeCategoryId
          });
        });
      }
    case ActionTypes.TEMPLATE_EDITOR_DELETE_ARTICLE_ON_HOME_PAGE:
      {
        const {
          categoryId,
          filteredArticles,
          position
        } = payload;
        return state.setIn(['knowledgeCategories', categoryId, 'articles'], filteredArticles.delete(position));
      }
    case ActionTypes.TEMPLATE_EDITOR_PUT_ARTICLE_ON_HOME_PAGE:
      {
        const {
          categoryId: knowledgeCategoryId,
          filteredArticles,
          articleId,
          position
        } = payload;
        return state.updateIn(['knowledgeCategories', knowledgeCategoryId], category => {
          if (category) {
            return category.set('articles', filteredArticles.set(position, articleId));
          }
          return HomepageCategoryRecord.fromJS({
            // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
            articles: new List().set(position, articleId).toJS(),
            knowledgeCategoryId
          });
        });
      }
    case ActionTypes.TEMPLATE_EDITOR_DROP_ARTICLE_ON_HOME_PAGE:
      {
        const {
          categoryId,
          draggedArticleId,
          droppedByArticleId,
          dropPosition
        } = payload;
        return state.updateIn(['knowledgeCategories', categoryId, 'articles'], articles => articles.remove(articles.indexOf(draggedArticleId)).insert(dropPosition === 'before' ? articles.indexOf(droppedByArticleId) : articles.indexOf(droppedByArticleId) + 1, draggedArticleId));
      }
    case ActionTypes.TEMPLATE_EDITOR_UPDATE_CATEGORY_COLOR:
      {
        const {
          categoryId: knowledgeCategoryId,
          color
        } = payload;
        return state.updateIn(['knowledgeCategories', knowledgeCategoryId], category => {
          if (category) {
            return category.merge({
              color
            });
          }
          return HomepageCategoryRecord.fromJS({
            color,
            knowledgeCategoryId
          });
        });
      }
    case ActionTypes.TEMPLATE_EDITOR_UPDATE_CATEGORY_ICON:
      {
        const {
          categoryId: knowledgeCategoryId,
          icon
        } = payload;
        return state.updateIn(['knowledgeCategories', knowledgeCategoryId], category => {
          if (category) {
            return category.merge({
              icon
            });
          }
          return HomepageCategoryRecord.fromJS({
            icon,
            knowledgeCategoryId
          });
        });
      }
    case ActionTypes.TEMPLATE_EDITOR_UPDATE_CATEGORY_IMAGE:
      {
        const {
          categoryId: knowledgeCategoryId,
          imageSrc
        } = payload;
        return state.updateIn(['knowledgeCategories', knowledgeCategoryId], category => {
          if (category) {
            return category.merge({
              imageSrc
            });
          }
          return HomepageCategoryRecord.fromJS({
            imageSrc,
            knowledgeCategoryId
          });
        });
      }
    case ActionTypes.TEMPLATE_EDITOR_UPDATE_CATEGORY_IMAGE_TYPE:
      {
        const {
          categoryId: knowledgeCategoryId,
          imageType
        } = payload;
        return state.updateIn(['knowledgeCategories', knowledgeCategoryId], category => {
          if (category) {
            return category.merge({
              imageType
            });
          }
          return HomepageCategoryRecord.fromJS({
            imageType,
            knowledgeCategoryId
          });
        });
      }
    default:
      return state;
  }
}